import { render, staticRenderFns } from "./DocumentFilesForm.vue?vue&type=template&id=86d73f78&"
import script from "./DocumentFilesForm.vue?vue&type=script&lang=js&"
export * from "./DocumentFilesForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFilesForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports